// A small joined row of buttons, exactly one of them on: pick a mode, see that mode.
//
// The same object as the reader's mode bar and the part selector, at control size and
// without their extras — no marks, no wrapping, no growing to fill a row. It is for a
// handful of short labels that name ways of looking at one thing (textured / wireframe /
// both) or ways of making it (reconstruct / upload), which is a choice small enough to sit
// inside a panel rather than above it.
//
// Its own file because there were two hand-written copies of it, and a third was about to
// be written. The border belongs to the GROUP and the segments are butted against each
// other inside it, so the row has one outline whatever it holds.
//
// THE ROW IS WHITE IN BOTH THEMES, and only the segment that is on is blue. The unselected
// segments used to be transparent, which on a dark page made them dark-on-dark beside a
// bright blue one — the row read as one button with two words floating next to it rather
// than as three choices. A white ground is what says the other two are pressable.
export function SegmentedToggle<T extends string>({ value, options, onChange, className, small = false }: {
  value: T;
  options: { value: T; label: string }[];
  onChange: (value: T) => void;
  // AN EXTRA GROUND UNDER THE ROW, for a caller that floats one over a picture — a shadow,
  // a translucency. The segments carry their own white, so this is only ever what shows at
  // the rounded corners; a caller does not need it to make the row legible.
  className?: string;
  // A SMALLER ROW, for a panel that is itself small print — the probe's readout, where the
  // standard row stood taller than the numbers it switches between.
  small?: boolean;
}) {
  return (
    // A LINE BETWEEN EACH TWO, full height (Louis 2026-10-29): two white segments side by side read as one.
    <div className={`inline-flex divide-x divide-slate-300 overflow-hidden rounded-lg border border-slate-300 ${className ?? ''}`}>
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          onClick={() => onChange(o.value)}
          aria-pressed={value === o.value}
          className={`${small ? 'px-2 py-0.5 text-[10px]' : 'px-3 py-1.5 text-xs'} whitespace-nowrap font-semibold transition-colors ${
            value === o.value
              ? 'bg-blue-600 text-white'
              : 'bg-white text-slate-600 hover:bg-slate-100'
          }`}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
